module.exports = __webpack_public_path__ + "fonts/Young-Italic.25a8c9ca.eot";